import React from 'react'
import { UserProfileHelper } from '@lura/shared'
import { ColorSquare } from './ColorSquare'

interface PatientIdProps {
  patientId: string
  size?: 'sm' | 'md' | 'lg'
}

export const PatientId: React.FC<PatientIdProps> = ({
  patientId,
  size = 'sm'
}) => {
  const displayName = UserProfileHelper.getAnonymizedId(patientId)
  const color = UserProfileHelper.getPatientColor(patientId)

  return (
    <span className="inline-flex items-center gap-2">
      <ColorSquare color={color} size={size} />
      <span>{displayName}</span>
    </span>
  )
}
